import ModalContainer from '@elements/ModalContainer'
import { useEffect, useState } from 'react'
import axios from '@utils/webRequests'
import BackTopbar, { TopbarClearfix } from '@elements/BackTopbar'

const TermsAndconditionsModal = ({ isOpen, setClosed }) => {
  const [policiesMarkdown, setPoliciesMarkdown] = useState('Loading Policies...')

  useEffect(() => {
    axios.get('/api/legal/policies', { params: { terms_and_conditions: true } })
      .then((res) => setPoliciesMarkdown(res.data))
      .catch(console.error)
  }, [])

  return (
    <ModalContainer
      noHeader
      open={isOpen}
      onClose={setClosed}>
      <BackTopbar title='Policies' />
      <TopbarClearfix />
      <div>{policiesMarkdown}</div>
    </ModalContainer>
  )
}

export default TermsAndconditionsModal
